import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

export default function RotaProtegida() {
  const { usuario, carregando, saiuDeProposito } = useAuth();
  const location = useLocation();
  // URL que o usuário tentou abrir direto (ex.: link de imóvel mandado pelo bot do Telegram) — vai
  // junto no `state` da navegação forçada, pra Login/TrocarSenha devolver pra cá no final em vez de
  // sempre cair no Dashboard (pedido do Jason, 29/09/2026: "seria bem profissional").
  const destino = location.pathname + location.search;

  if (carregando) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" />
      </div>
    );
  }

  // clicou em "Sair": vai para o login limpo, sem lembrar a página (a sessão EXPIRADA, ao contrário, lembra)
  if (!usuario && saiuDeProposito) return <Navigate to="/login" replace />;
  if (!usuario) return <Navigate to="/login" state={{ de: destino }} replace />;

  // Senha padrão ("123mudar") de usuário novo / redefinido pelo administrador: leva direto pra tela
  // de trocar (o backend também bloqueia as demais rotas até trocar). NÃO há mais troca a cada 30 dias.
  if (usuario.precisaTrocarSenha && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" state={{ de: destino }} replace />;
  }

  return <Outlet />;
}
